import type { DefaultNodeTypes } from '@payloadcms/richtext-lexical'
import type { JSXConvertersFunction } from '@payloadcms/richtext-lexical/react'
import React from 'react'

type NodeTypes = DefaultNodeTypes

// helper: detect "empty paragraph" like your example (text: "")
function isEmptyParagraph(node: any) {
  const children = node?.children
  if (!Array.isArray(children) || children.length === 0) return true

  // paragraph with a single text child of "" (or whitespace) should be treated as line break
  return children.every((c: any) => {
    if (c?.type !== 'text') return false
    const txt = typeof c?.text === 'string' ? c.text : ''
    return txt.trim() === ''
  })
}

/**
 * Coins AI Card converters:
 * - empty paragraph => 8px spacer
 * - normal paragraph => inline text + <br/>
 */
export const createCoinsAiCardConverters =
  (): JSXConvertersFunction<NodeTypes> =>
  ({ defaultConverters }) => ({
    ...defaultConverters,

    paragraph: ({ node, childIndex, converters, nodesToJSX, parent }) => {
      if (isEmptyParagraph(node)) {
        // exactly 8px "blank line"
        return <span key={childIndex} style={{ display: 'block', height: 8 }} aria-hidden="true" />
      }

      return (
        <React.Fragment key={childIndex}>
          <span>
            {nodesToJSX({
              nodes: node.children,
              parent: { ...node, parent },
              converters,
            })}
          </span>
          <br />
        </React.Fragment>
      )
    },
  })
